<template>
  <div class="d-flex flex-column px-4 px-md-0 justify-center container">
    <v-icon color="green" size="42" class="mb-4">check_circle_outline</v-icon>
    <div class="d-flex flex-column mb-12">
      <span class="text-subtitle-1 text-md-h6 font-weight-bold text-center"
        >Factura cargada con éxito</span
      >
      <span
        class="text-subtitle-2 text-md-subtitle-1 font-weight-regular grey--text text--darken-1 text-center"
        >En la sección “Facturación” verás reflejada la factura como
        <br class="d-none d-md-block" />
        “{{ invoiceStatus }}”.</span
      >
    </div>
    <div class="text-center d-md-flex flex-column align-center">
      <v-btn
        depressed
        large
        class="blue darken-2 white--text mb-4 text-subtitle-2"
        @click="
          $router.push({
            name: 'bill-list',
          })
        "
        >Ir a la facturación</v-btn
      >
      <v-btn
        text
        large
        color="blue darken-2"
        @click="$router.push({ name: 'visit-list' })"
        >Volver al inicio</v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "SuccessBillMessage",
  computed: {
    invoiceStatus() {
      if (this.$route.name === "AlternativeFormView") {
        return "Factura pendiente de validación";
      }
      if (this.$route.name === "bill-form") {
        return "Factura pendiente de pago";
      }

      return "";
    },
  },
};
</script>
